import React from 'react';
import appStyles from '../../styles/cr.module.scss';
import styles from '../../styles/DraftReportHeader.module.scss';
import { DateService } from "../../services";
import { CrBadges } from '../cr/CrBadges';
import { ICustomFieldDfn } from '../../types';
import { CrBreadcrumb } from '../cr/CrBreadcrumb';

export const DraftReportHeader = ({ title, reportDate, customFields, parents, reportingStage }: { title: string, reportDate: Date, customFields?: ICustomFieldDfn[], parents?: string[], reportingStage?: string }): React.ReactElement =>
    <div className={styles.draftReportHeader}>
        <div className={`${appStyles.fontSize20} ${appStyles.fontWeightSemibold}`}>
            <span>
                {title && <span>{title}{reportDate && ` - ${DateService.dateToUkLongDate(reportDate)}`}{reportingStage && ` ( ${reportingStage} )`} </span>}
                <CrBadges badges={customFields?.map(a => ({ text: a?.Title, badgeClass: appStyles.badgeSecondary }))} />
            </span>
        </div>
        {parents?.length > 0 &&
            <div className={`${styles.headerCrumbs} ${appStyles.fontSize16} ${appStyles.fontWeightSemibold}`}>
                <CrBreadcrumb items={parents} />
            </div>
        }
    </div>